import { forwardRef, type InputHTMLAttributes } from "react";

import { cn } from "./lib/cn";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

/** Ortak form kontrol stili — Input/Textarea/Select aynı görünümü paylaşır (kriter 5). */
export const fieldClasses = cn(
  "w-full rounded-md border border-slate-300 bg-white px-3 text-sm text-slate-900",
  "placeholder:text-slate-400",
  "focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20",
  "disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500",
  "aria-[invalid=true]:border-danger aria-[invalid=true]:ring-danger/20",
);

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, ...rest },
  ref,
) {
  return <input ref={ref} className={cn("h-10", fieldClasses, className)} {...rest} />;
});
